module.exports = __webpack_public_path__ + "img/bulletgreen.7efae81d.svg";